enum PspProvider {
  PAYEX = "PAYEX",
  ADYEN = "ADYEN"
}

export default PspProvider
